import { render } from "./BaseFolderThree.vue?vue&type=template&id=4e9c0164"
import script from "./BaseFolderThree.vue?vue&type=script&lang=js"
export * from "./BaseFolderThree.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__